<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "ParcelamentoContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("parcelamento_emitir")) {
				m.push({
					titulo: "Parcelamentos e Crediário",
					titulo_app: "Parcelamentos",
					icon: "mdi-file-document-outline",
					to: "/parcelamento",
					tooltip: "Emissão de parcelamentos de clientes",
				});
			}

			if (this.permissao("parcelamento_boleto")) {
				m.push({
					titulo: "Boletos",
					titulo_app: "Boletos",
					icon: "mdi-file-document-outline",
					to: "/parcelamento/boleto",
					tooltip: "Emissão de boleto para clientes",
				});
			}

      if (this.permissao("boleto_pix")) {
        m.push({
          titulo: "Boleto Pix",
          titulo_app: "Boleto Pix",
          icon: "mdi-file-document-outline",
          to: "/parcelamento/boleto_pix",
          tooltip: "Emissão de boleto com pix para clientes",
        });
      }

			if (this.permissao("parcelamento_conciliacao_visualizar")) {
				m.push({
					titulo: "Conciliação",
					titulo_app: "Conciliação",
					icon: "mdi-bank-check",
					to: "/parcelamento/conciliacao",
					tooltip:
						"Pagamentos de boletos, boletos a vencer e conciliação com os títulos",
				});
			}

			if (this.permissao("parcelamento_liberacao")) {
				m.push({
					titulo: "Liberação",
					titulo_app: "Liberação",
					icon: "mdi-file-document-outline",
					to: "/parcelamento/liberacao",
					tooltip:
						"Liberar clientes para parcelamento em condições especiais",
				});
			}

			if (this.permissao("parcelamento_remessa")) {
				m.push({
					titulo: "Remessa",
					titulo_app: "Remessa",
					icon: "mdi-file-document-outline",
					to: "/parcelamento/remessa",
					tooltip:
						"Gerar arquivo de remessa de boletos e reimpressão de arquivos gerados",
				});
			}

            if (this.permissao("parcelamento_carne")) {
                m.push({
                    titulo: "Boletos e Carnês",
                    titulo_app: "Boletos e Carnês",
                    icon: "mdi-file-document-outline",
                    to: "/parcelamento/carne",
                    tooltip:
                        "Emissão e impressão de boletos e carnês para clientes",
                });
            }

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>